import React from 'react';
import classnames from 'classnames';

export default function CardWrapper({
  children,
  className,
  containerClassName,
  title,
  description,
  extra,
  header,
  footer,
  style,
  ...rest
}) {
  function renderHeader() {
    const containerStyle = 'px-md py-md w-full border-b flex justify-between';

    if (header) {
      return <div className={containerStyle}>{header}</div>;
    }

    if (title) {
      return (
        <div className={containerStyle}>
          <div className="flex flex-col space-y-1 flex-shrink">
            <h6 className="mb-none">{title}</h6>
            {description && (
              <p className="text-gray-500 text-[10px]" style={{ lineHeight: 1.5 }}>
                {description}
              </p>
            )}
          </div>
          {extra && <div className="flex-none shrink-0">{extra}</div>}
        </div>
      );
    }

    return null;
  }

  return (
    <div
      className={classnames(
        'rounded-2xl bg-background-inkWhite-white_0 border border-solid border-brand-inkGrey-grey_2',
        containerClassName,
      )}
      {...rest}
    >
      {renderHeader()}
      <div className={classnames('p-md', className)} style={style}>
        {children}
      </div>
      {footer && <div className="px-md py-md w-full border-t">{footer}</div>}
    </div>
  );
}
